export const notes = [
    {
      patientName: 'Floyd miles 1',
      patientId: 1,
      profile: '',
      isBookMarked: true,
      notes: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore|',
      notesCreateDate: '28th Oct',
      id: 1
    },
    {
      patientName: 'Katherine Murphy 2',
      patientId: 2,
      profile: '',
      isBookMarked: false,
      notes: 'Katherin had posterior drainage, suggest a check up',
      notesCreateDate: '28th Oct',
      id:2
    },
    {
      patientName: 'Floyd miles 3',
      patientId: 3,
      profile: '',
      isBookMarked: true,
      notes: 'Suggest patient to join support group for cancer patients',
      notesCreateDate: '28th Oct',
      id:3
    },
    {
      patientName: 'Floyd miles 4',
      patientId: 4,
      profile: '',
      isBookMarked: true,
      notes: 'Suggest patient to josjdhin support group for cancer patients. Suggest patient to join support group for cancer patients .Suggest patient to join support group for cancer patients',
      notesCreateDate: '28th Oct',
      id:4
    },
    {
      patientName: 'Floyd miles 5',
      patientId: 5,
      profile: '',
      isBookMarked: true,
      notes: 'Suggest patient to join ksajdbcs csdjcbsjdh support group for cancer patients skjdbcs dcjshbdcjhb',
      notesCreateDate: '28th Oct',
      id:5
    },
    {
      patientName: 'Floyd miles 1',
      patientId: 6,
      profile: '',
      isBookMarked: true,
      notes: 'Suggest patient to join support group for cancer patients',
      notesCreateDate: '28th Oct',
      id: 6
    },
    {
      patientName: 'Floyd miles 1',
      patientId: 7,
      profile: '',
      isBookMarked: true,
      notes: 'Suggest patient to join support group for cancer patients',
      notesCreateDate: '28th Oct',
      id: 7
    },
  ];